import Cookies from 'js-cookie';
import { DEFAULT_REDIRECT_URL } from 'dashboard/constants/globals';
import { SESSION_STORAGE_KEYS } from 'dashboard/constants/sessionStorage';
import { frontendURL } from 'dashboard/helper/URLHelper';
import SessionStorage from 'shared/helpers/sessionStorage';
import { WEB_ORDER_ACCESS_PERMISSIONS } from 'dashboard/constants/permissions';

export const hasAuthCookie = () => {
  return !!Cookies.get('cw_d_session_info');
};

const getSSOAccountPath = ({ ssoAccountId, user }) => {
  const { accounts = [], account_id = null } = user || {};
  const ssoAccount = accounts.find(
    account => account.id === Number(ssoAccountId)
  );
  let accountPath = '';
  if (ssoAccount) {
    accountPath = `accounts/${ssoAccountId}`;
  } else if (accounts.length) {
    // If the account id is not found, redirect to the first account
    const accountId = account_id || accounts[0].id;
    accountPath = `accounts/${accountId}`;
  }
  return accountPath;
};

const capitalize = str =>
  str
    .split(/[._-]+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const getCredentialsFromEmail = email => {
  const [localPart, domain] = email.split('@');
  const namePart = localPart.split('+')[0];
  return {
    fullName: capitalize(namePart),
    accountName: capitalize(domain.split('.')[0]),
  };
};

const consumeAgentLoginGate = () => {
  const flagged = SessionStorage.get(SESSION_STORAGE_KEYS.AGENT_LOGIN_GATE);
  if (!flagged) return false;
  SessionStorage.remove(SESSION_STORAGE_KEYS.AGENT_LOGIN_GATE);
  return true;
};

export const getLoginRedirectURL = ({
  ssoAccountId,
  ssoConversationId,
  user,
}) => {
  const accountPath = getSSOAccountPath({ ssoAccountId, user });
  if (accountPath) {
    if (ssoConversationId) {
      return frontendURL(`${accountPath}/conversations/${ssoConversationId}`);
    }
    if (consumeAgentLoginGate()) {
      const account = (user?.accounts || []).find(
        item => `accounts/${item.id}` === accountPath
      );
      const permissions = account?.permissions || [];
      const canWebOrder =
        account?.role === 'administrator' ||
        permissions.includes('administrator') ||
        WEB_ORDER_ACCESS_PERMISSIONS.some(permission =>
          permissions.includes(permission)
        );
      if (canWebOrder) {
        return frontendURL(`${accountPath}/web-order/orders`);
      }
    }
    return frontendURL(`${accountPath}/dashboard`);
  }
  return DEFAULT_REDIRECT_URL;
};
